(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('ng-metadata/core'), require('angular')) :
	typeof define === 'function' && define.amd ? define(['exports', 'ng-metadata/core', 'angular'], factory) :
	(factory((global['connections-components'] = {}),global.core,global.angular));
}(this, (function (exports,core,angular) { 'use strict';

var __decorate$1 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var SocialSelfConnectComponent = /** @class */ (function () {
    function SocialSelfConnectComponent($scope, $mdDialog, $timeout, $mdMedia, $mdToast, $filter, $http, $attrs) {
        var _this = this;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.$timeout = $timeout;
        this.$mdMedia = $mdMedia;
        this.$mdToast = $mdToast;
        this.$filter = $filter;
        this.$http = $http;
        this.$attrs = $attrs;
        // tslint:disable-next-line:no-output-on-prefix
        this.onClick = new core.EventEmitter();
        this.companies = [];
        this.close = function () {
            _this.$mdDialog.hide();
        };
        this.getHeaders = function () {
            return { headers: { 'Authorization': _this.token, 'environment': _this.environment } };
        };
        this.popToast = function (message) {
            _this.$mdToast.show(_this.$mdToast.mwSimpleTimed()
                .textContent(message)
                .position('bottom right')
            //.parent(angular.element(document.getElementsByTagName('sc-self-connect')))
            );
        };
    }
    SocialSelfConnectComponent.prototype.handleClick = function (event) {
        this.onClick.emit(event);
    };
    /* lifecycle hooks (https://hotell.gitbooks.io/ng-metadata/content/docs/api/core/interface.html) */
    SocialSelfConnectComponent.prototype.ngOnInit = function () {
        if (this.channel === 'linkedin') {
            this.channel_dislay_name = 'LinkedIn';
        }
        else if (this.channel === 'facebook') {
            this.channel_dislay_name = 'Facebook';
        }
        if (this.environment === 'production') {
            this.apiUrl = 'https://selfconnect-api.section31.meltwater.io';
        }
        else if (this.environment === 'staging') {
            this.apiUrl = 'https://selfconnect-api.staging.section31.meltwater.io';
        }
        else if (this.environment === 'development') {
            this.apiUrl = 'https://selfconnect-api.dev.section31.meltwater.io';
        }
        if (this.apiUrl === '') {
            console.error('Error: environment not configured properly for ' + this.channel_dislay_name + ' self connect component.');
        }
        this.GetConnectedPagesInit();
    };
    SocialSelfConnectComponent.prototype.ngAfterViewInit = function () {
        // Called after this controller's element and its children have been linked, do any DOM initialization here
    };
    SocialSelfConnectComponent.prototype.ngOnChanges = function (changes) {
        // Called whenever one-way bindings are updated.
    };
    SocialSelfConnectComponent.prototype.ngOnDestroy = function () {
        // Called when containing scope is destroyed. Use this hook for releasing external resources, watches and event handlers.
    };
    SocialSelfConnectComponent.prototype.startconnect = function () {
        if (this.appname == null) {
            alert('invalid app');
        }
        if (this.channel === null) {
            alert('no Channel');
        }
        var childwindow = this.PopupCenter(this.apiUrl + '/api/selfconnect/' + this.channel +
            '?app=' + this.appname +
            '&companyId=' + this.companyid +
            '&userId=' + this.userid, 'popup', this.width, this.height);
    };
    // tslint:disable-next-line: max-line-length
    SocialSelfConnectComponent.prototype.PopupCenter = function (url, title, w, h) {
        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
        // tslint:disable-next-line: max-line-length
        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
        var systemZoom = width / window.screen.availWidth;
        var left = (width - w) / 2 / systemZoom + dualScreenLeft;
        var top = (height - h) / 2 / systemZoom + dualScreenTop;
        // tslint:disable-next-line: max-line-length
        var newWindow = window.open(url, title, 'scrollbars=no, width=' + w / systemZoom + ', height=' + h / systemZoom + ', top=' + top + ', left=' + left);
        // Puts focus on the newWindow
        if (window.focus) {
            newWindow.focus();
        }
        // I know this next part looks hokey, it is a hack used by FB
        // and others to capture a window.close event for cross origin
        // we have to capture 'this' because it loses scope with the setInterval call
        var this2 = this;
        var timer = setInterval(function () {
            if (newWindow.closed) {
                clearInterval(timer);
                setTimeout(function () {
                    this2.$scope.$apply(function () {
                        this2.fetchStatus = 'loading';
                        this2.GetConnectedPagesInit();
                        this2.fetchStatus = '';
                    });
                }, 1000);
            }
        }, 1000);
    };
    SocialSelfConnectComponent.prototype.GetConnectedPagesInit = function () {
        var _this = this;
        // tslint:disable-next-line: max-line-length
        this.$http.get(this.apiUrl + '/api/selfconnect/' + this.appname + '/' + this.channel + '/' + this.companyid, this.getHeaders())
            .then(function (response) {
            _this.connectedAccounts = response.data;
        }).catch(function (response) {
            console.error('There was an error while retrieving connected accounts', response.status, response.data);
        }).finally(function () {
        });
    };
    SocialSelfConnectComponent.prototype.deleteConnection = function (id) {
        var _this = this;
        this.$http.delete(this.apiUrl + '/api/selfconnect/' + id).then(function (response) {
            var this2 = _this;
            setTimeout(function () {
                this2.$scope.$apply(function () {
                    this2.GetConnectedPagesInit();
                });
            }, 1000);
        }).catch(function (response) {
            console.error('There was an error trying to remove a connection', response.status, response.data);
        });
    };
    __decorate$1([
        core.Input(),
        __metadata("design:type", String)
    ], SocialSelfConnectComponent.prototype, "classname", void 0);
    __decorate$1([
        core.Input(),
        __metadata("design:type", String)
    ], SocialSelfConnectComponent.prototype, "channel", void 0);
    __decorate$1([
        core.Input(),
        __metadata("design:type", Number)
    ], SocialSelfConnectComponent.prototype, "height", void 0);
    __decorate$1([
        core.Input(),
        __metadata("design:type", Number)
    ], SocialSelfConnectComponent.prototype, "width", void 0);
    __decorate$1([
        core.Input(),
        __metadata("design:type", String)
    ], SocialSelfConnectComponent.prototype, "appname", void 0);
    __decorate$1([
        core.Input(),
        __metadata("design:type", String)
    ], SocialSelfConnectComponent.prototype, "environment", void 0);
    __decorate$1([
        core.Input(),
        __metadata("design:type", String)
    ], SocialSelfConnectComponent.prototype, "companyid", void 0);
    __decorate$1([
        core.Input(),
        __metadata("design:type", String)
    ], SocialSelfConnectComponent.prototype, "userid", void 0);
    __decorate$1([
        core.Input(),
        __metadata("design:type", String)
    ], SocialSelfConnectComponent.prototype, "token", void 0);
    __decorate$1([
        core.Output(),
        __metadata("design:type", core.EventEmitter)
    ], SocialSelfConnectComponent.prototype, "onClick", void 0);
    __decorate$1([
        core.Input(),
        __metadata("design:type", Object)
    ], SocialSelfConnectComponent.prototype, "config", void 0);
    SocialSelfConnectComponent = __decorate$1([
        core.Component({
            selector: 'sc-self-connect',
            template: "\n    <!-- Header -->\n        <div layout=\"row\">\n            <div>\n                <h4>{{$ctrl.channel_dislay_name}}</h4>\n            </div>\n\n            <div flex layout=\"row\" layout-align=\"end center\">\n                <md-button ng-click=\"$ctrl.startconnect()\" class=\"mw-button md-primary md-button\" type=\"button\">ADD ACCOUNT</md-button>\n            </div>\n        </div>\n        <div style=\"padding: 8px;\">\n            Authenticate your account to access {{$ctrl.channel_dislay_name}} data in {{$ctrl.appname}}. Once authenticated, your data will begin to flow into the system within moments.\n        </div>\n        \n        <div ng-if=\"$ctrl.connectedAccounts.length === 0\" style=\"padding-top: 15px;\">\n            <hr />\n            <div layout=\"row\" layout-align=\"center\" style=\"padding-top: 15px;padding-bottom: 10px;\">\n                Click on the \"Add Account\" button to connect your {{$ctrl.channel_dislay_name}} profile\n            </div>\n        </div>\n        <div ng-if=\"$ctrl.connectedAccounts.length > 0\">\n            \n            <div layout=\"row\" ng-repeat=\"account in $ctrl.connectedAccounts\" style='border-bottom:1px solid #ccc; padding: 20px; margin: 10px;'>\n                <img src='{{account.connected_page_logo}}' style=\"height: 40px;width: 40px;\" align=\"center\" />\n                <span style=\"padding-left: 5px; font-size: 1.3em;font-weight: bold\">{{account.connected_page_name}}<br/>\n                    <font style=\"font-weight: normal;font-size: small;\">Connected by: {{account.connecting_user_name}}</font>\n                </span>\n                    \n                <div flex layout=\"row\" layout-align=\"end right\">\n                    <font style=\"color: #34B7BD\">CONNECTED <br />\n                        <font style=\"font-size: small;color: #000\">Expires in {{account.expiration_days}} days ({{account.expiration_date}})</font>\n                    </font>\n                    <md-menu class=\"mw-menu\" md-position-mode=\"target-left target\" md-offset=\"0 50\">\n                    <mw-menu-trigger-icon-button class=\"mw-button md-icon-button\" tooltip=\"{{'Open Menu' | translate}}\" on-click=\"$mdMenu.open($event)\" icon=\"navigation:ic_more_vert_24px\"></mw-menu-trigger-icon-button>\n                    <md-menu-content class=\"mw-menu-dropdown\" md-padding=\"md-padding\">\n                        <mw-menu-item type=\"focusdummy\" md-autofocus></mw-menu-item>\n                        <mw-menu-item type=\"singleselect\" icon=\"action:ic_delete_24px\" on-click=\"$ctrl.deleteConnection(account.credential_id)\">Delete</mw-menu-item>\n                        <mw-menu-item type=\"singleselect\" icon=\"meltwater:social\" on-click=\"$ctrl.startconnect()\">Reconnect</mw-menu-item>\n                    </md-menu-content>\n                    </md-menu>\n                </div>\n            </div>\n            <!-- Loading Spinner -->\n            <div ng-if=\"$ctrl.fetchStatus === 'loading'\">\n                <mw-loader></mw-loader>\n            </div>\n        </div>\n"
        }),
        __param(0, core.Inject('$scope')),
        __param(1, core.Inject('$mdDialog')),
        __param(2, core.Inject('$timeout')),
        __param(3, core.Inject('$mdMedia')),
        __param(4, core.Inject('$mdToast')),
        __param(5, core.Inject('$filter')),
        __param(6, core.Inject('$http')),
        __param(7, core.Inject('$attrs')),
        __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object, Object, Object])
    ], SocialSelfConnectComponent);
    return SocialSelfConnectComponent;
}());

var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ConnectionsModule = /** @class */ (function () {
    function ConnectionsModule() {
    }
    ConnectionsModule = __decorate([
        core.NgModule({
            imports: ['ngMaterial'],
            declarations: [
                SocialSelfConnectComponent
            ],
            providers: []
        })
    ], ConnectionsModule);
    return ConnectionsModule;
}());
var index = angular.module('ConnectionsModule', [
    'ngMaterial',
    core.bundle(ConnectionsModule).name
]);

exports['default'] = index;
exports.SocialSelfConnectComponent = SocialSelfConnectComponent;

Object.defineProperty(exports, '__esModule', { value: true });

})));



/*****************
 ** WEBPACK FOOTER
 ** ./~/@meltwater/connections-components/connections-components.umd.js
 ** module id = 155
 ** module chunks = 0 1
 **/